import { z } from 'zod';

export const formSchema = z.object({
  deliveryDate: z.date({
    required_error: 'Informe a data de entrega'
  }),
  description: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>